<template>
  <!--  #app-body .app-content > nav вешает gap: 16px; для VTabsV2 этот стиль лишний; приходится писать контейнер nav -->
  <nav>
    <VTabsV2
      :tabs="tabs"
      base-url="/profile"
      @update="onTabUpdate"
    />

    <!-- #app-body .app-content > nav > :last-child вешает margin-left: auto; чтобы этот стиль не применился на вкладки, создаю div -->
    <div />
  </nav>

  <ProfileMainInfoSection
    v-if="activeTab?.id === 'main'"
    :partner="$core.currentPartner"
    :user="$core.currentUser"
    @update="updateCurrentUser"
  />

  <template v-if="activeTab?.id === 'companies'">
    <CompaniesSection
      @companies:updated="updateCurrentUser"
      :local-partner="$core.currentPartner"
    />
    <br>
    <BankAccountsSection :local-partner="$core.currentPartner" />
  </template>

  <StoresSection
    v-if="activeTab?.id === 'stores'"
    id="stores-section"
    :local-partner="$core.currentPartner"
    @stores:updated="updateCurrentUser"
  />

  <ProfileContractsSection
    v-if="activeTab?.id === 'documents'"
  />

  <PersonsSection
    v-if="activeTab?.id === 'persons'"
    id="persons-section"
    :localPartner="$core.currentPartner"
    @persons:updated="updateCurrentUser"
    @persons:created="updateCurrentUser"
  />
</template>

<style lang="scss" scoped>
#persons-section, #stores-section {
  max-width: 700px;
}
</style>

<script lang="ts">

import TabElement              from '@/lib/components/VTabsV2/TabElement';
import TimeZonesService 	     from "@/domains/TimeZones/TimeZonesService";

import BankAccountsSection     from '@/domains/BankAccounts/components/BankAccountsSection/BankAccountsSection.vue';
import CompaniesSection 	     from '@/domains/Companies/components/CompaniesSection/CompaniesSection.vue';
import ChangePassword 		     from './components/ChangePassword/ChangePassword.vue';
import StoresSection 			     from '@/domains/Stores/components/StoresSection/StoresSection.vue';
import ProfileMainInfoSection  from "@/pages/common/ProfilePage/components/ProfileMainInfoSection/ProfileMainInfoSection.vue";
import ProfileContractsSection from "@/pages/common/ProfilePage/components/ProfileContractsSection/ProfileContractsSection.vue";
import PersonsSection          from "@/domains/Persons/PersonsSection/PersonsSection.vue";

export default {
	name: 'Profile',

	components: {
    PersonsSection,
		ProfileContractsSection,
		ProfileMainInfoSection,
		BankAccountsSection,
		CompaniesSection,
		ChangePassword,
		StoresSection,
	},

	data() {
		return {
			TimeZonesService,

			tabs: [
				TabElement.from('main',      'Основная информация'),
				TabElement.from('companies', 'Счета и юр. лица'   ),
				TabElement.from('stores',    'Склады'             ),
				TabElement.from('documents', 'Документы'          ),
				TabElement.from('persons',   'Контакты'           ),
			] as TabElement[],

			/**
			 * Активная вкладка — сообщает VTabsV2 (@update), страница роут
			 * не парсит. Дефолтный сегмент обеспечивает роутер
			 * (/profile → redirect /profile/company).
			 */
			activeTab: null as TabElement | null,
		};
	},

	methods: {
		/** Активную вкладку сообщает VTabsV2 — из роута в router-mode */
		onTabUpdate(tab: TabElement | null) {
			this.activeTab = tab;
		},

		async updateCurrentUser() {
      await this.$core.acl.updateCurrentUserData();
    },
	},
};
</script>
